module.exports = __webpack_public_path__ + "static/media/HCMM227.a0c09470.jpg";